import {BitmapText} from "pixi.js";
import {BS2GameAssets} from "../BS2GameAssets";
import {BS2} from "../BS2";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";


export class FreespinCounterView extends PIXI.Container {

    private _freespinCountNumber: BitmapText;
    private _freespinName: PIXI.Text;
    private _flame: PIXI.spine.Spine;
    private _candle: PIXI.Sprite;
    private _shockWaveEffect: TimelineSprite;

    private readonly _styleName = {
        dropShadow: true,
        dropShadowAngle: 90,
        dropShadowBlur: 1,
        dropShadowDistance: 4,
        fill: [
            "#c90000",
            "#ff321d"
        ],
        fontFamily: OpenSans.FAMILY,
        fontWeight: FontWeight.BOLD,
        miterLimit: 1,
        strokeThickness: 7,
        fontSize: 15
    }

    constructor() {
        super();
        this.name = "freespinCounter";
        this.position.set(-3, -45);
        this.init();

    }

    public startFlame(): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{
            this._flame.visible = true;
            this._flame.alpha = 1;
            this._flame.state.setAnimation(0, "Loop", true)
        });
    }

    public showShockWave(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._shockWaveEffect.visible = true;
        })
        tl.add(this._shockWaveEffect.getAnimation());
        tl.add(() => {
            this._shockWaveEffect.visible = false;
        })
        return tl;
    }

    public showCount(spinsLeft: number): void {
        if (spinsLeft <= 0) {
            this._freespinCountNumber.text = "";
            this._freespinName.text = "";
            const tl = gsap.timeline();

            tl.add(gsap.to(this._freespinCountNumber, {duration: 0.4, alpha: 0}));
            tl.add(gsap.to(this._freespinName, {duration: 0.4, alpha: 0}), "<");
            tl.add(this.stopFlame(),"<");

            return;
        } else {
            this.startFlame();
        }

        let counterText:string = "";
        if(BS2.getSkinName()==="us-nonfree"){
            if (BS2.model.isNextSuperFreespin()) {
                counterText = (spinsLeft == 1 ? "BONUS SPIN" : "BONUS SPINS");
            } else if (BS2.model.isNextFreeSpin()) {
                counterText = (spinsLeft == 1 ? "SPIN" : "SPINS");
            }
        }else {
            if (BS2.model.isNextSuperFreespin()) {
                counterText = (spinsLeft == 1 ? "BONUS SPIN" : "BONUS SPINS");
            } else if (BS2.model.isNextFreeSpin()) {
                counterText = (spinsLeft == 1 ? "SPIN" : "SPINS");
            }
        }


        this._freespinName.text = BS2.apiPlugin.translations.translate(counterText);
        this._freespinCountNumber.text = spinsLeft.toString();
        this._freespinCountNumber.pivot.set(this._freespinCountNumber.width / 2, this._freespinCountNumber.height / 2);

        const tl = gsap.timeline();
        tl.add(gsap.to(this._freespinCountNumber, {duration: 0.1, alpha: 1}));
        tl.add(gsap.to(this._freespinName, {duration: 0.1, alpha: 1}), "<");
        tl.add(gsap.to(this._flame, {duration: 0.1, alpha: 1}), "<");


    }

    private stopFlame(): gsap.core.Timeline {
        const tl=gsap.timeline();
        tl.add(()=>{
            this._flame.state.setAnimation(0, "off", false);
        });
        tl.to(this,{duration:this._flame.skeleton.data.findAnimation("off").duration});
        tl.add(()=>{
            this._flame.visible=false;
            this._flame.alpha=0;
            this._flame.state.setEmptyAnimation(0,0);
            this._flame.state.clearTracks();
            this._flame.skeleton.setBonesToSetupPose();
            this._flame.skeleton.setSlotsToSetupPose();

        })
        return tl;
    }

    private init(): void {
        this._freespinCountNumber = new BitmapText("", {
            fontName: BS2GameAssets.BITMAP_FONT_CANDLE_NUMBER,
            fontSize: 10,
            letterSpacing: 12,
        });
        this._freespinCountNumber.alpha = 0;
        this._freespinCountNumber.position.set(361, 67);

        this._freespinName = new PIXI.Text("");
        this._freespinName.style = this._styleName;
        this._freespinName.alpha = 0;
        this._freespinName.anchor.set(0.5, 0.5);
        this._freespinName.position.set(363, 93);

        this._flame = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.CANDLE_FLAME_SPINE));
        this._flame.alpha = 0;
        this._flame.position.set(360, 89);

        this._candle = new PIXI.Sprite(BS2.assetLoader.getTextures("Candle")[0]);
        this._candle.anchor.set(0.5, 0.5);
        this._candle.position.set(364, 67)

        this._shockWaveEffect = new TimelineSprite(BS2.assetLoader.getTextures("shockWaveEffect"));
        this._shockWaveEffect.blendMode = 1;
        this._shockWaveEffect.anchor.set(0.5, 0.5);
        this._shockWaveEffect.scale.set(0.5, 0.5);
        this._shockWaveEffect.position.set(360, 60);
        this._shockWaveEffect.tint = 0xf51100;
        this._shockWaveEffect.visible=false;

        this.addChild(this._candle, this._flame, this._freespinName, this._shockWaveEffect, this._freespinCountNumber);
    }

}